import React, { createRef, useState } from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { classNames } from "primereact/utils";
import "../css/Register.css";
import { useNavigate } from "react-router-dom";
import { InputMask } from 'primereact/inputmask';
import { Toast } from 'primereact/toast';
import { InputOtp } from 'primereact/inputotp';
import { apiClient } from "../apiClient";
import { useOnlineStatus } from "../context/OnlineContext";
import colors from '../colors';
import CryptoJS from 'crypto-js';


function Register() {
  
  const [showMessage, setShowMessage] = useState(false);
  const navigate = useNavigate();
  const [user,setUser] = useState();
  const [registerData,setregisterData] = useState();
  const toast = createRef();
  const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
  const { online, setOnline } = useOnlineStatus();
  const [finished,setFinished] = useState(false);
  const config = {headers: { "Content-Type": "application/json" }};


  const encryptData = (message) => {
    const secretKey = process.env.REACT_APP_ACCESS_JWT_SECRET;
  
    if (!secretKey) {
        throw new Error("Encryption key is missing!");
    }

    // 🔹 Ensure key is 32 bytes
    const key = CryptoJS.enc.Utf8.parse(secretKey.padEnd(32, ' '));

    const encrypted = CryptoJS.AES.encrypt(message, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    }).toString();

    return encrypted;
};

          
 

  const formik = useFormik({
    
    initialValues: {
    
      name: "",
      familyName:"",
      phone:"",
      password: "",
      accept:false,
     
    },

    validate: async (values) => {
      
      let errors = {};

      if (!values.password) {
        errors.password = "رمز عبور الزامی است";
      }
      // if (!values.accept) {
      //   errors.accept = "باید با قوانین و مقررات سایت موافقت کنید";
      // }
     
      if(!(await uniquePhone(values.phone)))
      {
        errors.phone  = "این شماره موبایل قبلا ثبت شده";
      }
      if (!values.phone) {
        errors.phone = "شماره موبایل  الزامی است";
      }
     
      if (!values.name) {
        errors.name = "نام الزامی است";
      }
      if(!values.familyName)
      {
        errors.familyName="نام خانوادگی الزامی است"
      }
     
  
      

      
      return errors;
    },
    
    onSubmit: (values) => {

      

      const data = JSON.stringify({ role:"subscriber" , name:values.name.trim() , familyName:values.familyName.trim() ,phone:values.phone.replace(/[^0-9]+/g, ""),password: values.password});
      setregisterData(data);

    
         
          setShowMessage(true);

        //creating user in database
        const config = {     
          headers: { 
            'Content-Type': 'application/json'
        }
      }
    
      apiClient.post(process.env.REACT_APP_BACK+"/users/register", data, config)
          .then(response => 
            {
            
              if (response.status == 201)
              {
                
                setUser(response.data);
                setFinished(true);



              }
          })
          .catch(error => {
             console.log(error);
          
          });
          
            

      
      
      

     
    },
  });



  const isFormFieldValid = (phone) =>
    !!(formik.touched[phone] && formik.errors[phone]);
  const getFormErrorMessage = (phone) => {
    return (
      isFormFieldValid(phone) && (
        <small className="p-error">{formik.errors[phone]}</small>
      )
    );
  };


  //check if phone is unique:
  const uniquePhone = (value) =>
 {
      const config = {     
        headers: { 'Content-Type': 'application/json' }
    }
        return new Promise((resolve, reject) => {
          

            apiClient.get(process.env.REACT_APP_BACK+"/users/check-phone/"+value.replace(/[^0-9]+/g, ""), config)
                .then((res) => {
                  if(res.data==="")
                    resolve(true)
                    else
                    resolve(false)
                })
                .catch((error) => {
                        resolve(false);
                   
                    
                })
        })
    
  }
      
   


      

  const passwordHeader = <h6>یک رمز عبور انتخاب کنید</h6>;
  const passwordFooter = (
    <React.Fragment>
      <Divider />
      <p className="mt-2">پیشنهادات</p>
      <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: "1.5" }}>
        <li>حداقل یک کاراکتر انگلیسی کوچک</li>
        <li>حداقل یک کاراکتر انگلیسی بزرگ</li>
        <li>حداقل یک عدد</li>
        <li>حداقل یک رمز 8 کاراکتری</li>
      </ul>
    </React.Fragment>
  );

  return (


    
    
      <div className="form-demo register-form">


            <Toast ref={toast } style={{background:"red", color:"#ffffff", zIndex:"10000", margin:"0px"}} life="3000" position="center center"/>



         <Dialog
          visible={finished}
          onHide={() => setFinished(false)}
          position="top"
          showHeader={false}
          breakpoints={{ "960px": "80vw" }}
          style={{ width: "30vw" }}
        >
          <div className="flex align-items-center flex-column pt-6 px-3">
            <i
              className="pi pi-check-circle"
              style={{ fontSize: "5rem", color: "var(--green-500)" }}
            ></i>
            <h4>!ثبت نام موفقیت آمیز بود</h4>
            <p style={{ lineHeight: 1.5, textIndent: "1rem" }}>
              به 
              &nbsp;
              {process.env.REACT_APP_PROJECT_NAME}
              &nbsp;
               خوش آمدید
            </p>
            <p style={{ lineHeight: 1.5, textIndent: "1rem" }}>
              لطفاً در داشبورد کاربران، پلن مورد نظر خود برای تولید محتوا را انتخاب کنید
            </p>

            <div><Button  label="بزن بریم" className="p-button mt-2 filled-button" onClick={async()=>{
            
              
              
              //cache user:
              await localStorage.setItem("seo_app", JSON.stringify(user));

              //cache token:
              const payload = {payload:encryptData(user._id+","+user.role)};
              
              await apiClient.post(process.env.REACT_APP_BACK+"/users/getToken/", JSON.stringify(payload), config)
              .then((response) => 
                {
                  
                  if(response.status === 201)
                  {
    
                    localStorage.setItem("userToken", JSON.stringify(response.data));
                    // Set online status to true
                    setOnline(true);
                    
                    
                  }
                  
                })
                .catch(function (error) {
                  console.log("error",error);
               
    
                });

              // Set online status to true
              await setOnline(true);

              //go to dashboard:
               navigate("/dashboard/account");
              
              

              }}/></div>

          </div>
        </Dialog> 

        <div>
          <div>
            
         
            <form onSubmit={formik.handleSubmit} className="p-fluid" style={{textAlign:'right'}}>

            
         

              <div className="field">
                <span>
                  <label
                    htmlFor="name"
                    className={classNames({
                      "p-error": isFormFieldValid("name"),
                    })}
                  >
                    نام:
                  </label>
                  <InputText
                    id="name"
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("name"),
                    })}
                    maxLength={25} 
                  />
                </span>
                {getFormErrorMessage("name")}
              </div>

              <div className="field">
                <span>
                  <label
                    htmlFor="familyName"
                    className={classNames({
                      "p-error": isFormFieldValid("familyName"),
                    })}
                  >
                    نام خانوادگی:
                  </label>
                  <InputText
                    id="familyName"
                    name="familyName"
                    value={formik.values.familyName}
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("familyName"),
                    })}
                    maxLength={25} 
                  />
                </span>
                {getFormErrorMessage("familyName")}
              </div>

              

          

              <div className="field">
                <span>
                  <label
                    htmlFor="phone"
                    className={classNames({
                      "p-error": isFormFieldValid("phone"),
                    })}
                  >
                    شماره موبایل:
                  </label>
                  <InputMask 
              id="phone"
              name="phone"
              mask="(0999) 9999999" 
              value={formik.values.phone}
              onChange={formik.handleChange}
              style={{ direction: "ltr", textAlign: "left" }}
              placeholder="(0919)9999999"
              className={classNames({
                "p-invalid": isFormFieldValid("phone"),
              })}
              ></InputMask>
                 
                </span>
                {getFormErrorMessage("phone")}
              </div>
            

           


              
              <div className="field">
                <span>
                  <label
                    htmlFor="password"
                    className={classNames({
                      "p-error": isFormFieldValid("password"),
                    })}
                  >
                    رمز عبور:
                  </label>
                  <Password
                    id="password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    promptLabel="لطفاً یک رمز عبور انتخاب کنید"
                    strongLabel="قوی"
                    mediumLabel="متوسط"
                    weakLabel="ضعیف"
                    toggleMask
                    className={classNames({
                      "p-invalid": isFormFieldValid("password"),
                    })}
                    header={passwordHeader}
                    footer={passwordFooter}
                    panelStyle={{direction:"rtl"}}
                  />
                </span>
                {getFormErrorMessage("password")}
              </div>



              {/* <div className="field-checkbox">
                
                <Checkbox
                  id="accept"
                  name="accept"
                  checked={formik.values.accept}
                  onChange={formik.handleChange}
                  
                  className={classNames({
                    "p-invalid": isFormFieldValid("accept"),
                  })}
                />
                <label
                  htmlFor="accept"
                  className={classNames({
                    "p-error": isFormFieldValid("accept"),
                  })}
                >
                  من با قوانین و مقررات سایت موافقم*
                </label>
                
                
                
              </div>
              <div>{getFormErrorMessage("accept")}</div> */}

              <Button type="submit" label="ثبت نام" className="mt-2 filled-button" />
              

            </form>
          </div>
        </div>
      </div>
    
  );
}

export default Register;
